import { render, staticRenderFns } from "./write.vue?vue&type=template&id=9a2e315e&scoped=true&"
import script from "./write.vue?vue&type=script&lang=js&"
export * from "./write.vue?vue&type=script&lang=js&"
import style0 from "./write.vue?vue&type=style&index=0&id=9a2e315e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2e315e",
  null
  
)

export default component.exports